<template>
  <div v-if="isShowTemplate" :id="wrapperId" class="share-wrapper">
    <div class="share-content-wrapper">
      <img src="/assets/img/logo-share-header-soco.svg" alt="asd" width="100px" />
      <div class="card-review-detail share-card">
        <div class="share-userinfo--uniform">
          <div class="card-userinfo--uniform">
            <GImageUser
              :user="reviewData.user"
              class="img-user"
              :username="reviewData.user.user_name"
              :src="reviewData.user.image"
              class-name="avatar"
              :alt="reviewData.user.user_name"
              :user-level="reviewData.user.user_level"
              :is-expert-review="reviewData.user.is_expert_reviewer"
              is-use-base64
            />
            <div class="userinfo">
              <div class="userinfo-name is-expert-detail">
                <div>
                  <h4 class="username">{{ reviewData.user.name }}</h4>
                </div>
                <span class="label-profile">{{ convertName(reviewData.user.expert_role) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="share-card-content">
          <img class="label-expert" src="/assets/img/expert-review-label.svg" alt="" width="120" />
          <div class="share-product-wrapper">
            <img
              data-v-726701f3=""
              :src="productImage || reviewData.product.images[0].url"
              loading="lazy"
              :alt="reviewData.product.name"
              onerror="this.src='/assets/img/dummy_product.svg'"
              class="share-product-image"
              width="48"
            />
            <div class="share-product-info">
              <div class="share-brand-name">
                {{ reviewData.product.brand.name.toUpperCase() }}
              </div>
              <div class="share-product-name">
                {{ reviewData.product.name }}
              </div>
            </div>
          </div>
          <GRatingInline
            :average-rating="reviewData.average_rating"
            :star-fill-number="Math.ceil(reviewData.average_rating * 10)"
            is-use-local-image
          />
          <p>
            {{ reviewData.details }}
          </p>
        </div>
      </div>
      <div v-if="isFacebook" class="share-caption">
        Baca <span>tried & tested review</span> langsung dari<br />
        Expert berpengalaman!
      </div>
    </div>
    <div class="share-footer">
      <img v-if="isFacebook" src="/assets/img/icon-soco-beauty-super-app.svg" alt="" height="38" />
      <div v-if="isWhatsapp" class="share-caption">
        Baca <span>tried & tested review</span><br />
        langsung dari Expert berpengalaman!
      </div>
      <div class="app-link-wrapper">
        <img src="/assets/img/logo-share-soco.svg" alt="logo" width="38" />
        <div class="app-link-text-wrapper">
          <div>INSTALL & Shop now</div>
          <div class="app-link-wrapper">
            <img src="/assets/img/logo-appstore.svg" alt="appstore" height="18" />
            <img src="/assets/img/playstore.svg" alt="playstore" height="18" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GImageUser from '@/components/global/GImageUser.vue';
export default {
  name: 'share-template',
  components: {
    GImageUser,
  },
  props: {
    reviewData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    type: {
      type: String,
      required: true,
      default: () => 'wa',
    },
  },
  data() {
    return {
      productImage: '',
    };
  },
  computed: {
    wrapperId() {
      return `share-${this.type}-${this.reviewData._id}`;
    },
    isHaveReviewData() {
      return Boolean(Object.values(this.reviewData).length);
    },
    isShowTemplate() {
      if (this.isHaveReviewData) {
        const { user } = this.reviewData;
        return Boolean(user.is_expert_reviewer && user.expert_role && user.name);
      }
      return false;
    },
    isWhatsapp() {
      return this.type === 'wa';
    },
    isFacebook() {
      return this.type === 'fb';
    },
  },
  mounted() {
    this.replaceComponentToLastOnApp();
    this.setProductImageToBase64();
  },
  updated() {
    this.replaceComponentToLastOnApp();
    this.setProductImageToBase64();
  },
  methods: {
    convertName(name) {
      const words = name.split('_');
      return words[0].charAt(0).toUpperCase() + words[0].slice(1) + ' ' + words.slice(1).join(' ').toLowerCase();
    },
    replaceComponentToLastOnApp() {
      if (this.isHaveReviewData) {
        const doc = document.getElementById(this.wrapperId);
        if (doc) {
          doc.remove();
          document.getElementById('app').appendChild(doc);
        }
      }
    },
    async setToBase64(url, state) {
      try {
        const data = await fetch(url, { cache: 'no-cache' }).then((res) => res.blob());
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            const { result } = reader;
            this[state] = result;
            resolve(result);
          };
          reader.readAsDataURL(data);
          reader.onerror = reject;
        });
      } catch (err) {
        console.error(err);
        this.productImage = url;
        return Promise.resolve(url);
      }
    },
    setProductImageToBase64() {
      if (this.isHaveReviewData) {
        this.setToBase64(this.reviewData.product.images[0].url, 'productImage');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './../../dashboard/snippet/card-review-expert';
@import './share-template';
</style>
